<div class="popup confirmAreaPopup">
    <div class="confirmAreaPopup-img" [ngClass]="chosenAreaImageClass"></div>
    <h1 class="confirmAreaPopup-title _primary" [i18nKey]="title"></h1>

    <p class="confirmAreaPopup-message">
        {{message | async}}
    </p>

    <div class="confirmAreaPopup-action">
        <button (click)="cancel()" class="button _cancel">{{cancelButtonMessage}}</button>
        <button (click)="confirm()" class="button">{{confirmButtonMessage}}</button>
    </div>
</div>
<div class="overlay"></div>
